export const initialState = {
  notifications: [],
  menuOpened: false,
};
